
    import './styles.scoped.css';
    export default {
  "content-wrapper": "awsui_content-wrapper_zycdx_sml4c_13",
  "content-wrapper-mobile": "awsui_content-wrapper-mobile_zycdx_sml4c_17",
  "content-type-dashboard": "awsui_content-type-dashboard_zycdx_sml4c_22"
};
  